import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/signIn';
import $R from 'plugins/tfs/platformConfigs/integrationMaps/routes';
import React, { useState, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { fetchPermissions } from 'actions/permissions';
import { fetchPackageStatuses } from 'actions/packageStatuses';
import { fetchTransferStatuses } from 'actions/transferStatuses';
import { objectSelector } from 'theme/utils';

// pageContainer
import StaffLogin from '_pageContainers/login/staffLogin';

import AuthForm from 'theme/captchaAuth/AuthForm';
import $S from 'theme/settings';

const StaffLoginGrid = (pageContext) => {
  const dispatch = useDispatch();

  const siteKey = process.env.REACT_APP_CAPTCHA_KEY;

  const {
    props: { success, pending, error },
    selectedStaff,
    onLogin,
  } = pageContext;

  const [loginError, setLoginError] = useState({ count: 0 });
  const [showButton, setShowButton] = useState(true);

  const staffName = objectSelector(selectedStaff, 'first_name', '');
  const staffLastName = objectSelector(selectedStaff, 'last_name', '');
  const staffEmail = objectSelector(selectedStaff, 'email', '');

  useEffect(() => {
    if (Object.keys(error).length > 0) {
      setLoginError((prev) => ({ ...prev, count: prev.count + 1 }));
      if (loginError.count > 1) {
        setShowButton(false);
      }
    }
  }, [error]);

  function onChange() {
    setInterval(() => {
      setShowButton(true);
    }, 300);
  }

  if (success) {
    dispatch(fetchPackageStatuses(selectedStaff.id));
    dispatch(fetchTransferStatuses(selectedStaff.id));
    if ($S.hasPermissionForPages) {
      dispatch(fetchPermissions(selectedStaff.id));
    }
    return <Redirect push to={$R.MAIN_HOME.path} />;
  }

  return (
    <div className='container-fluid headerMargin__onlyLogo'>
      <div className='row'>
        <div className='col-12 col-md-6'>
          <div className='row justify-content-md-center login_form-container'>
            <div className='col-12 col-md-8'>
              <div className='login_partial-container'>
                <h1 className='selected-store' style={{ color: '#000' }}>
                  {$ST.SELECTED_USER}
                </h1>
                {selectedStaff && (
                  <div className='addresses'>
                    <p className='address__title'>
                      {staffName}
                      {staffLastName}
                    </p>
                    <p className='address__content'>
                      {`
                        ${staffEmail}`}
                    </p>
                    <AuthForm
                      authPending={pending}
                      error={error}
                      email={staffEmail}
                      display={showButton}
                      login={(formData) => {
                        onLogin(formData);
                      }}
                    />
                    {loginError.count > 2 && (
                      <div className='mt-2'>
                        <ReCAPTCHA
                          sitekey={siteKey}
                          hl={'nl'}
                          onChange={onChange}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffLogin(StaffLoginGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/login/staffLogin/index.js